import React from 'react';

export const EmbedModeContext = React.createContext<boolean>(false);
export const useEmbedMode = () => React.useContext(EmbedModeContext);
